import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Badge } from "@/shared/ui/badge";
import { Clock, TrendingUp, TrendingDown } from "lucide-react";

export function ShiftPerformanceWidget() {
  const shifts = [
    {
      name: "Morning Shift",
      time: "06:00 - 14:00",
      status: "completed",
      output: 1240,
      target: 1200,
      efficiency: 103,
      quality: 98.5,
      trend: "up",
    },
    {
      name: "Afternoon Shift",
      time: "14:00 - 22:00",
      status: "active",
      output: 856,
      target: 1200,
      efficiency: 71,
      quality: 97.2,
      trend: "down",
    },
    {
      name: "Night Shift",
      time: "22:00 - 06:00",
      status: "upcoming",
      output: 0,
      target: 1000,
      efficiency: 0,
      quality: 0,
      trend: "neutral",
    },
  ];

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "active":
        return <Badge className="bg-success hover:bg-success/90 text-xs">Active</Badge>;
      case "completed":
        return <Badge variant="outline" className="text-xs">Completed</Badge>;
      case "upcoming":
        return <Badge variant="outline" className="text-xs text-muted-foreground">Upcoming</Badge>;
      default:
        return null;
    }
  };

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Clock className="h-4 w-4" />
          Shift Performance
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1 space-y-3">
        {shifts.map((shift) => (
          <div key={shift.name} className="p-3 rounded-lg border bg-card">
            <div className="flex items-center justify-between mb-2">
              <div>
                <p className="text-sm font-medium">{shift.name}</p>
                <p className="text-xs text-muted-foreground">{shift.time}</p>
              </div>
              {getStatusBadge(shift.status)}
            </div>
            {shift.status !== "upcoming" && (
              <div className="grid grid-cols-3 gap-2 mt-2">
                <div>
                  <p className="text-xs text-muted-foreground">Output</p>
                  <p className="text-sm font-bold">
                    {shift.output}/{shift.target}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">Efficiency</p>
                  <p
                    className={`text-sm font-bold flex items-center gap-1 ${
                      shift.efficiency >= 100 ? "text-success" : shift.efficiency >= 80 ? "text-warning" : "text-destructive"
                    }`}
                  >
                    {shift.efficiency}%
                    {shift.trend === "up" && <TrendingUp className="h-3 w-3" />}
                    {shift.trend === "down" && <TrendingDown className="h-3 w-3" />}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">Quality</p>
                  <p className="text-sm font-bold">{shift.quality}%</p>
                </div>
              </div>
            )}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
